import { Component, Input, OnChanges, inject } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@angular/fire/auth';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { Observable } from 'rxjs';
import { AuthService } from '@app/core/services/auth.service';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { SettingsDialogService } from '@app/core/services/settings-dialog';

@Component({
  selector: 'app-user-menu',
  imports: [
    CommonModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatMenuModule,
  ],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.css',
})
export class UserMenuComponent implements OnChanges {
  @Input() user!: User | null;
  userData$!: Observable<any>;
  firstWord = '';

  private readonly settingsDialog = inject(SettingsDialogService);

  constructor(
    private router: Router,
    private auth: AuthService,
    private snack: SnackbarService,
  ) {
    this.userData$ = this.auth.userDoc$();
  }

  ngOnChanges() {
    if (this.user?.displayName) {
      this.firstWord = this.user.displayName.split(' ')[0];
    }
  }

  /** Opens settings in place (no routing) with a shareable /settings?tab=… URL. */
  goToSettings(tab: string) {
    this.settingsDialog.open(tab);
  }

  /** Cross-project "everything I've handed to a human" list. */
  goToRequests() {
    this.router.navigate(['/engagements']);
  }

  snackMsg() {
    this.snack.showInfo('Dark theme coming soon..', 2000);
  }

  logout() {
    this.auth.signOut().subscribe(() => {
      console.log('User logged out.');
      localStorage.removeItem('user');
    });
  }
}